import PropTypes from 'prop-types'
import { Doughnut } from 'react-chartjs-2'
import { Chart as ChartJS, registerables } from 'chart.js'

ChartJS.register(...registerables)

const PieChart = ({ data, onClick }) => {
  const getGraphData = () => ({
    labels: data.labels,
    datasets: [
      {
        data: data.values,
        backgroundColor: data.colors,
        hoverBackgroundColor: data.colos,
      },
    ],
  })

  const graph = getGraphData()

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    layout: {
      padding: 0,
    },
    plugins: {
      legend: {
        display: true,
        position: 'left',
        align: 'start',
        labels: {
          font: { size: 12 },
          padding: 12,
        },
      },
      tooltip: {
        enabled: true,
      },
    },
    onClick,
  }

  return <Doughnut height={125} data={graph} options={options} />
}

PieChart.propTypes = {
  data: PropTypes.object.isRequired,
  onClick: PropTypes.func.isRequired,
}

export default PieChart
